<template>
          <hooper
        v-if="menu.desktop_kiosk_left_bar && !isSearchKiosk"
        :vertical="true"
        :style="makeStyles(kioskBorder,'height: 80vh',categoryCarouselBorderColor, verticalCategoryCarouselWidth, verticalCategoryCarouselBackgroundColor, verticalCategoryCarouselHeight, verticalCategoryCarouselBorderRadius)"
        :class="[
          'relative ml-12 mt-6 border-opacity-25 border-l-2',
        ]"
        :itemsToShow="itemsToShow"
        :centerMode="false"
        :infiniteScroll="!!!isStaticSideMenu"
        :trimWhiteSpace="!!isStaticSideMenu"
        ref="carousel3"
        @change="$emit('onSelect')"
        @click="$emit('onSelect')"
        :keysControl="true"
      >
        <slide v-for="(item, i) in menuCategories" :key="item.id + slideHeight" class="p-3"
        :style="index == i ? `${makeStyles(kioskCurrentCatBorderLeft, categoryCarouselBackgroundColor)}; height: ${slideHeight}` : `height: ${slideHeight}`">
          <div
          v-if="((hasKiosk && !isMobileDevice) ? (currentKioskMode == lang['take_away'][language]) ? item.is_take_out : (currentKioskMode == lang['dine_in'][language] ? item.is_dine_in : true) : true)"
            ref="category"
            :class="[
              index != i && 'opacity-60',
              index == i ? 'border-l-4' : '',
              'cursor-pointer flex flex-col justify-center h-full',
            ]"
            :style="index == i ? (kioskCurrentCatBorderLeft): ''"
            @click="$emit('carouselClick',i)"
          >
            <span class="hidden" id="categoryId">{{ item.Id }}</span>
            <div
                v-if="item.picture_url"
                :class="['flex justify-center h-full', desktopMode ? 'h-32' : 'h-60p']"
              >
              <span :class="['w-3/5 flex justify-center z-10', verticalCategoryCarouselWidth !== 'false' ? 'items-center' : '']">
              <span class='fade h-full'>
                <img
                  :src="item.picture_url"
                  :class="[
                    'fade-img h-full rounded-lg',
                    desktopMode ? 'object-contain' : 'object-cover',
                  ]"
                />
              </span>
              </span>
              </div>
              <div class="w-full flex justify-center">
                <div :class="['namePosition text-center']">
                  <p
                    id="currentCategoryTitle"
                    :class="[
                      'text-gray-800',
                      desktopMode ? 'text-md' : 'text-md',
                    ]"
                    :style="makeStyles(kioskNavCategoryName , titleFont,titleTextTransform)"
                    ref="title"
                  >
                    {{ item[`name_${language}`] }}
                  </p>
                </div>
              </div>
          </div>
        </slide>
      </hooper>
</template>

<script>
import lang from "../lang";
import { mapGetters } from "vuex";

import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";
import _ from "lodash";
export default {
    data() {
        return {
            lang: lang,
            slideHeight:0
        };
    },
    props: {
        desktopMode: {
            type: Boolean,
            default() {
                return false;
            },
      },
      index: {
        type: Number,
        default:0
      }
  },
  components: {
    Hooper,
    Slide,
  },
  watch: {
      isStaticSideMenu() {
        this.setSlideHeight();
      }
  },
  computed: {
    ...mapGetters([
      "isSearchKiosk",
      "menuCategories",
      "language",
      "menu",
      "hasKiosk",
      "currentKioskMode",
      "isMobileDevice",
     
    ]),
    ...mapGetters("Theme", [
      "kioskBorder",
      "titleFont",
      "titleTextTransform",
      "kioskCurrentCatBorder",
      "kioskCurrentCatBorderLeft",
      "kioskNavCategoryName",
      "categoryCarouselHeight",
      "categoryCarouselBorderColor",
      "categoryCarouselBackgroundColor",
      "verticalCategoryCarouselWidth",
      "carouselItemsCount",
      "verticalCategoryCarouselBackgroundColor",
      "verticalCategoryCarouselHeight",
      "verticalCategoryCarouselBorderRadius",
      "isStaticSideMenu",
      "customThemeVariables"
    ]),  
    itemsToShow() {
      if (this.carouselItemsCount && this.hasKiosk) {
        if (this.isStaticSideMenu) return this.menuCategories.length + 2;
        
        return Number(this.carouselItemsCount);
      }

      return window.innerHeight > 900 ? 4.5 : 3;
  },
    showCategories() {
      return this.menuCategories.length > 1;
    },
  },
  methods: {
    setSlideHeight() {
      if (this.isStaticSideMenu) {
        const hooperList = this.$el.querySelector('.hooper-list');
        const computedStyle = window.getComputedStyle(hooperList);
        const paddingTop = parseFloat(computedStyle.paddingTop);
        const paddingBottom = parseFloat(computedStyle.paddingBottom);
        const height = hooperList.clientHeight;
        const heightMinusPadding = height - paddingTop - paddingBottom;
        const slideHeight = heightMinusPadding / (this.menuCategories.length);
        return this.slideHeight = `${slideHeight}px`;
      }
      return this.slideHeight = this.categoryCarouselHeight;
    }
  },
    mounted() {
      // Select the first element with the class 'hooper-list'
      this.$nextTick(() => {

        const hooperList = document.querySelector('.hooper-list');
        hooperList.classList.add('py-18');
        if (hooperList) {
          hooperList.style.borderRadius = this.customThemeVariables['vertical-category-carousel--border-radius']; 
        }
        this.setSlideHeight(); 
    })
  },
}
</script>

<style lang="scss" scoped>

</style>